import { TFilterItem, TItemGroup, TItemValue } from 'types';

export const flattenItemValues = (items: TFilterItem[]): string[] => {
  const values: string[] = [];

  items.forEach((item) => {
    if ('value' in item) {
      values.push(item.value);
    } else if ('items' in item) {
      item.items.forEach((subItem) => values.push(subItem.value));
    }
  });

  return values;
};

export const getGroupedItems = (items: TFilterItem[]): TItemGroup[] => {
  const groupedItems: TItemGroup[] = [];
  const ungrouped: TItemValue[] = [];

  items.forEach((item) => {
    if ('value' in item) {
      ungrouped.push(item);
    } else if ('items' in item) {
      groupedItems.push(item);
    }
  });

  if (ungrouped.length > 0) {
    groupedItems.push({ group: 'ungrouped', items: ungrouped });
  }

  return groupedItems;
};
